import $ from 'jquery'
import { useCognitoAuthStore } from '@base-shared/stores/cognito-auth'
import { useUserStore } from '@base-shared/stores/user'
import { useGroupStore } from '@base-shared/stores/group'
import { watch } from 'vue'
import EventBus from '@/components/mixins/event-bus-mixin'
import DataStore from '@/globals/data-store.js'
import CurrentUser from '@/globals/current-user-info.js'

/**
 * AuthPlugin is a Vue plugin that handles user authentication events
 *
 * FIXME: This plugin should be refactored to use Pinia data flow instead
 * of relying on EventBus and callbacks. Once we'll introduce AuthStore
 * and UserStore, all necessary data should be automatically propogated
 * to the components that use it, without the need for manual event handling.
 */
const AuthPlugin = {
  install (app, options) {
    const signedInUserDetails = options.signedInUserDetails;
    const signedInUserAccounts = options.signedInUserAccounts;
    const signedInUserInfo = options.signedInUserInfo;
    const router = options.router;
    const userStore = useUserStore();
    const groupStore = useGroupStore();

    // Replacement for BIND_USER_DETAILS_IN_VUE
    watch(() => userStore.currentUser, (newValue) => {
      if (!newValue) {
        signedInUserDetails.value = null;
        return;
      }

      signedInUserDetails.value = {
        ...newValue,
        name: newValue.firstName || newValue.lastName
          ? (`${newValue.firstName} ${newValue.lastName}`).trim()
          : ''
      };
    }, {
      deep: true
    });

    // Replacement for BIND_USER_ACCOUNTS_IN_VUE
    watch(() => userStore.accounts, (newValue) => {
      signedInUserAccounts.value = newValue;
    }, {
      deep: true
    });

    // Replacement for BIND_USER_INFO_IN_VUE
    watch(() => groupStore.groupInfo, async (newValue) => {
      // Legacy code used to populate `_edit` property on
      // the signedInUserInfo from AuthMixin.
      signedInUserInfo.value = newValue
        ? CurrentUser.filterUserInfoFromBackend(newValue)
        : null;

      // Handle suspended account redirection
      if (signedInUserInfo.value?.activePlan?.suspended) {
        await router.aryaSuspendedRedirection();
      }
    }, {
      deep: true
    });

    // Reset DataStore on SIGNED_IN event
    EventBus.$on('SIGNED_IN', (payLoad) => {
      DataStore.default()
    })

    EventBus.$on('SIGNED_OUT', (payLoad) => {
      signedInUserDetails.value = null
      signedInUserAccounts.value = []
      signedInUserInfo.value = null
    })

    /**
     * If user session will refresh then pass the new token to each template to keep token updated
     */
    EventBus.$on('USER_SESSION_UPDATED', async () => {
      let session
      try {
        session = await useCognitoAuthStore().fetchAndStoreAuthSession()
      } catch {
        // Missing/expired auth session should not break token refresh propagation.
        session = null
      }

      const token = session?.tokens?.idToken?.toString() ?? ''

      $('.template-target-on-refresh-token').each((indx, el) => {
        if ($(el).length) {
          $(el)[0].contentWindow.postMessage({
            projectOptions: {
              token
            }
          }, '*')
        }
      })
    })
  }
}

export default AuthPlugin;
